function getOpt (pmData, pointData) {

 let xData = pmData.xData;
 let y1Data = pmData.yData;
 let y2Data = [];
 return {
  backgroundColor: "transparent",
  tooltip: {
   show: true,
   trigger: 'axis',
   axisPointer: {
    type: "line",
    snap: true
   },
   backgroundColor: "#000",
   padding: 10,
   textStyle: {
    color: "#fff",
   },
   formatter: function (params) {
    let res;
    if (params[0]) {
     try {
      res = `<span>时间: ${params[0].axisValue}</span></br>`;
      res += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#00FFFF;"></span></span><span>${params[0].value.toFixed(2)}</span></br>`;
     } catch {
     }
    }
    return res;
   },
  },
  legend: {
   show: false,
   icon: 'circle',
   left: '40%',
   top: '8%',
   // data: [{ name: '常规监测', icon: "circle" }, { name: '可见烟尘识别记录 ', icon: "circle" }],
   formatter: function (name) {
    return name;
   },
   textStyle: {
    fontSize: 14,
    color: 'rgba(255,255,255,0.6)',
    padding: [2, 0, 0, 0]
   },
   selectedMode: false,
  },
  grid: {
   top: '25%',
   left: '8%',
   right: '6%',
   bottom: '0%',
   containLabel: true,
  },
  xAxis: [{
   type: 'category',
   axisLine: {
    show: true,
    lineStyle: {
     color: 'rgba(9, 62, 149, 1)',
     width: 1
    },
   },
   boundaryGap: true,
   axisLabel: {
    textStyle: {
     color: "rgba(159, 186, 253, 1)",
     fontSize: 14,
     margin: 15,
    },
    formatter: function (value) {
     let res = value;
     if (res) {
      //时间太长剪切一下
      res = res.substring(5, 16);
     }
     return res;
    }
   },
   axisTick: {
    show: false,
   },
   data: xData,
  }],
  yAxis: [{
   name: '单位：mg/m³',
   nameTextStyle: {
    fontSize: 14,
    color: "rgba(159, 186, 253, 1)",
    padding: [0, 0, 0, 80]
   },
   type: 'value',
   // min: function (data) {
   //  let minData
   //  minData = data.min * 0.9;
   //  minData = minData.toFixed(2)
   //  return minData
   // },
   // minInterval: 50,
   // max: function (data) {
   //  let maxData
   //  maxData = data.max * 1.1;
   //  maxData = maxData.toFixed(2)
   //  return maxData
   // },
   splitLine: {
    show: false,
    lineStyle: {
     color: 'rgba(9, 62, 149, 1)',
     width: 0.3
    }
   },
   axisLine: {
    show: true,
    lineStyle: {
     color: 'rgba(9, 62, 149, 1)',
     width: 1
    }
   },
   axisLabel: {
    margin: 10,
    textStyle: {
     color: 'rgba(159, 186, 253, 1)',
     fontSize: 14,
    },
   },
   axisTick: {
    show: false,
   },
  }],
  series: [
   {
    name: "",
    type: 'line',
    smooth: true,
    showSymbol: false,
    symbolSize: 0,
    lineStyle: {
     normal: {
      width: 2,
      color: "#00FFFF"
     }
    },
    itemStyle: {
     normal: {
      color: "#00FFFF",
     }
    },
    data: y1Data
   }, {
    name: '',
    type: 'scatter',
    // legendHoverLink: true,
    symbolSize: 15,
    itemStyle: {
     color: '#00FFFF'
    },
    data: [[pointData.dateTime, pointData.value]],
   }]
 };
}

export default getOpt